import { render, staticRenderFns } from "./WallSpeakersBlockGeneralSettings.vue?vue&type=template&id=330941a8"
import script from "./WallSpeakersBlockGeneralSettings.vue?vue&type=script&lang=js"
export * from "./WallSpeakersBlockGeneralSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports